import { cn } from '@/utils/cn'

interface Props {
  label: string
  value: string
  valueClassName?: string
}

export const BorrowMarketParameterRow = ({ label, value, valueClassName }: Props) => (
  <div className="flex min-h-11 items-center border-b last:border-b-0">
    <dt className="min-w-0 flex-1 py-2 pr-2 text-sm">{label}</dt>
    <dd className={cn('min-w-0 flex-1 py-2 pl-2 text-right text-heading-foreground text-sm', valueClassName)}>
      {value}
    </dd>
  </div>
)
